import React from 'react';
import Media from 'react-media';

import { HeaderTestIds } from '@trello/webdriverio-tests';
import classNames from 'classnames';
// eslint-disable-next-line no-restricted-imports
import ClientConfig from 'common/debug/client-config';

// eslint-disable-next-line no-restricted-imports
import { ScreenBreakpoints } from 'components/responsive';
// eslint-disable-next-line no-restricted-imports
import SearchForm from 'components/search/form';
// eslint-disable-next-line no-restricted-imports
import printStyles from 'components/shared/print.less';

// eslint-disable-next-line no-restricted-imports
import { RouteContext } from 'common/components/route-context';
// eslint-disable-next-line no-restricted-imports
import BackToHomeLink from 'components/header/back-to-home-link';
// eslint-disable-next-line no-restricted-imports
import DesktopSettingsButton from 'components/header/desktop-settings-button';
// eslint-disable-next-line no-restricted-imports
import NotificationsMenuButton from 'components/header/notifications-menu-button';
import HeaderBoardMenuButton from './board-menu-button';
import ChannelSwitcherButton from './channel-switcher-button';
import CreateMenuButton from './create-menu-button';
import EnterpriseMenuButton from './enterprise-menu-button';
import HeaderLogo from './header-logo';
import InfoMenuButton from './info-menu-button';
import MemberMenuButton from './member-menu-button';
import Roo from './roo';

// eslint-disable-next-line no-restricted-imports
import { MemberModel } from 'types';

import styles from './header.less';

const isDesktop = ClientConfig.get('appId') === 'desktop';

interface AuthenticatedHeaderProps {
  alwaysOpenBoardsMenu: boolean;
  member: MemberModel | undefined;
  currentRoute: string | null;
}

export const AuthenticatedHeader: React.FunctionComponent<
  AuthenticatedHeaderProps
> = ({ member, alwaysOpenBoardsMenu, currentRoute }) => (
  <RouteContext>
    {({ isBoardRoute, isCardRoute, isSearchRoute }) => (
      <div
        id="header"
        className={classNames(
          styles.header,
          !isBoardRoute && !isCardRoute && styles.default,
          printStyles.noPrint,
        )}
        data-test-id={HeaderTestIds.Container}
      >
        <div className={styles.leftSection}>
          <BackToHomeLink />
          {!alwaysOpenBoardsMenu && <HeaderBoardMenuButton />}
          {!isSearchRoute && <SearchForm />}
          <Roo />
        </div>
        <HeaderLogo />
        <div className={styles.rightSection}>
          <CreateMenuButton />
          <Media query={ScreenBreakpoints.MediumMin}>
            {(matches: boolean) =>
              matches &&
              !isDesktop && (
                <div className={styles.flexContainer}>
                  <InfoMenuButton />
                </div>
              )
            }
          </Media>
          <NotificationsMenuButton />
          <EnterpriseMenuButton />
          <Media query={ScreenBreakpoints.MediumMin}>
            {(matches: boolean) =>
              matches && (
                <div className={styles.flexContainer}>
                  <ChannelSwitcherButton />
                </div>
              )
            }
          </Media>
          <MemberMenuButton member={member} />
          {!!isDesktop && <DesktopSettingsButton />}
        </div>
      </div>
    )}
  </RouteContext>
);



// WEBPACK FOOTER //
// ./app/gamma/src/components/header/authenticated-header.tsx